import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

export function AnodeCathodeSlot(props) {
  return (
    <div className={`ps_interactionArea  ${props.className}`}>
      <div id='anode_slot' className='ps_interactionArea_anode' />
      <div id='cathode_slot' className='ps_interactionArea_cathode' />
    </div>
  );
}

AnodeCathodeSlot.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
};
